import React from "react";
import { dialog, Button, FormFactory } from "nq-component";
import Table from "../../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../../../withRouter";
import BaseListPage from "../../../../../base/BaseListPage";
import Presenter from "./Presenter";
import InputFactory from "../../../../../components/InputFactory";
import AdditionalTalbePresenter from "../additional-info/AdditionalTalbePresenter";
import SearchSelect from "../../../../../components/searchSelect/SearchSelect";
import {
  DialogConfirmation,
  FloatingForm,
} from "../../../../../components/common/Converter";
import CardView from "../../../../../components/common/CardView";
import Progress from "../../../../../components/Progress";

class CivilPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AdditionalTalbePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      objects: [],
      object: {},
      careerService: "",
      ratings: "",
      placeofExam: "",
      numbers: "",
      objectID: "",
      initialData: [],
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "service_eligibility";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const newObject = await findObjectUseCase().execute("service_eligibility", {
      where: { empID: this.props.object.id },
    });
    this.setState({ initialData: newObject });
  }

  getCurrent() {
    return this.props.object.id;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.objects !== this.state.objects) {
      // if (this.state.initialData.length > 0) {
      //   console.log("initialEmails: ");
      const initialEmails = new Set(
        this.state.initialData.map((data) => data.civilCareer),
      );
      const newObjects = this.state.objects.filter(
        (data) => !initialEmails.has(data.civilCareer),
      );
      if (newObjects.length > 0) {
        console.warn("NEWLY ADD: ", newObjects);
        localStorage.setItem("CivilService", JSON.stringify(newObjects));
      }
      // }
    }
  }

  // delete function
  async handleDeleteData(data) {
    // const deletedData = await findObjectUseCase().execute(
    //   "service_eligibility",
    //   { where: { id: id } }
    // );
    // const prevDelete =
    //   JSON.parse(localStorage.getItem("DeleteEducation")) || [];
    // const updatedDeleteData = prevDelete.concat(deletedData);
    // localStorage.setItem("DeleteEducation", JSON.stringify(updatedDeleteData));

    // await this.presenter.deleteObjectUseCase.execute("service_eligibility", id);
    // dialog.close();
    // this.refetchData();
    DialogConfirmation(data.id, this.getCollectionName(), () =>
      this.refetchData(),
    );
  }

  // edit function
  handleObjectData(object) {
    console.log("CARRR: ", object);
    this.setState({ addCivil: true, object: object });
  }

  onChangeForm(value, field) {
    this.setState({ [field]: value });
  }

  serviceEligibility() {
    this.setState({ addCivil: true, object: {} });
  }

  async handleSaveButton() {
    let data = {
      email: this.props.object.email,
      empID: this.props.object.id,
      civilCareer: this.state.civilCareer,
      civilRating: this.state.civilRating,
      civilExamination: this.state.civilExamination,
      civilExaminationFrom: this.state.civilExaminationFrom,
      civilExaminationTo: this.state.civilExaminationTo,
      civilPlace: this.state.civilPlace,
      civilLicense: this.state.civilLicense,
      civilValidity: this.state.civilValidity,
      specify: this.state.specify,
    };
    if (Object.keys(this.state.object).length > 0 && this.state.object.id) {
      data = { ...this.state.object, specify: this.state.specify };
    }
    console.log("DATA: ", data);
    await this.presenter.upsertUseCase.execute("service_eligibility", data);

    this.refetchData();
    this.setState({ objectID: "", addCivil: false });
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;

    const excludeField = ["civilCareer"];
    const exclude = Object.keys(schema.fields).filter(
      (key) => !excludeField.includes(key),
    );
    if (!schema) return <Progress />;
    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > object.length}
          >
            <div className="p-3 p-lg-4">
              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <div className="d-flex align-items-center justify-content-center">
                  <div style={{ marginLeft: "auto" }}>
                    <Button
                      // onClick={this.handleAddRegion.bind(this)}
                      onClick={this.serviceEligibility.bind(this)}
                    >
                      <i className="bi bi-plus-lg" /> Add Eligibility
                    </Button>
                  </div>
                </div>
              </div>

              <Table
                objectId={(data) => this.handleDeleteData(data)}
                objectData={this.handleObjectData.bind(this)}
                // editId={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: "Remove",
                    actionType: "delete",
                  },
                  {
                    label: "Edit",
                    actionType: "object",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At"],
                )}
                // selected={selected}
                // onSelect={this.onSelect.bind(this)}
                // onSelectAll={this.onSelectAll.bind(this)}
                // progress={progress}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.addCivil && (
          <FloatingForm width="55rem">
            <CardView style={{ padding: 0 }}>
              <h4 className="fs-6 fw-bold pt-3 ps-3">Eligibility</h4>
              <hr />
              <form
                className="p-3"
                onSubmit={(e) => {
                  e.preventDefault();
                  this.handleSaveButton();
                }}
              >
                <FormFactory
                  className="pb-2"
                  schema={schema}
                  object={this.state.object}
                  // disabled={true}
                  onChange={this.onChangeForm.bind(this)}
                  excludeFields={exclude}
                />
                {/* {(this.state.civilCareer === "Others" ||
                  this.state.object.civilCareer === "Others") && (
                  <InputFactory
                    type="String"
                    defaultValue={this.state.object.specify}
                    className="form-control"
                    placeholder="Specify"
                    onChange={(val) => this.onChangeForm(val, "specify")}
                  />
                )} */}
                <FormFactory
                  className="pb-2"
                  schema={schema}
                  object={this.state.object}
                  onChange={this.onChangeForm.bind(this)}
                  excludeFields={["email", "civilCareer", "specify"]}
                />
                <hr />
                <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                  <Button
                    type="button"
                    className="btn btn-light fs-sm"
                    onClick={() => this.setState({ addCivil: false })}
                  >
                    Cancel
                  </Button>
                  <Button type="submit" className="btn btn-primary">
                    Submit
                  </Button>
                </div>
              </form>
            </CardView>
          </FloatingForm>
        )}
      </>
    );
  }
}

export default CivilPage;
